import { Headers, ResolvedApiMethod } from '../../types/types';
import { fetcher } from './fetcher';

// Wrapper for fetcher to handle detailed api method requests
export const detailedApiMethodFetcher = async <T>(
  apiMethod: ResolvedApiMethod,
  forceHeader?: string,
  additionalHeaders?: Headers,
  returnHeaders?: boolean,
  longRunning = true
): Promise<T> => {
  let headers: Headers = {};
  // Fallback to GET method if not specified
  const httpMethod = apiMethod.httpMethod ?? 'GET';

  Object.keys(apiMethod?.headers ?? {}).forEach((key) => {
    const value = apiMethod?.headers?.[key];

    if (value === undefined || value === null) {
      return;
    }

    headers[key] = value.toString();
  });

  if (additionalHeaders) {
    headers = { ...headers, ...additionalHeaders };
  }

  return await fetcher<T>(
    apiMethod.path,
    httpMethod,
    null,
    forceHeader,
    apiMethod.queryParams,
    apiMethod.content,
    headers,
    returnHeaders,
    apiMethod.errorResponse,
    longRunning
  );
};
